import { Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as emojiFlags from 'emoji-flags';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-table-cell-emoji',
  templateUrl: './emoji-table-cell.component.html',
  styles: ['.emoji {font-size:16px;}', '.code {position:relative; top: -3px;}'],
  standalone: false,
})
export class EmojiTableCellComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  ngOnDestroy() {}

  getEmoji() {
    const contryCode = emojiFlags.countryCode(this.data);
    return contryCode ? contryCode.emoji : this.data;
  }
}
